import type {
  BrokerQuote,
  QuoteStage,
} from "@/lib/submissions/brokerSubmissions";
import { QuoteChipBadge } from "@/components/submissions/QuoteChipBadge";
const LABEL: Record<QuoteStage, string> = {
  offered: "Offered",
  selected: "Selected",
  binding: "Bind requested",
  bound: "Bound",
  expired: "Expired",
  withdrawn: "Withdrawn",
  not_taken: "Not taken",
  draft: "Draft",
  superseded: "Superseded",
};
/** Kind and lifecycle come from PMS; a selection never implies bound. */
export function QuoteProvenance({
  quote,
  statusLabel,
}: {
  quote: BrokerQuote;
  statusLabel?: string;
}) {
  return (
    <span className="flex flex-wrap items-center gap-2">
      <QuoteChipBadge
        chip={{
          label: quote.kind === "quote" ? "Quote" : "Indication",
          tone: quote.kind === "quote" ? "quoted" : "draft",
        }}
      />
      {quote.stage && LABEL[quote.stage] !== statusLabel && (
        <QuoteChipBadge
          chip={{
            label: LABEL[quote.stage] ?? quote.stage,
            tone:
              quote.stage === "binding"
                ? "waiting_on_carrier"
                : quote.stage === "bound"
                  ? "bound"
                  : "draft",
          }}
        />
      )}
    </span>
  );
}
